import { render } from "./TableMassive.vue?vue&type=template&id=678fcf38&scoped=true"
import script from "./TableMassive.vue?vue&type=script&lang=js"
export * from "./TableMassive.vue?vue&type=script&lang=js"

import "./TableMassive.vue?vue&type=style&index=0&id=678fcf38&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678fcf38"]])

export default __exports__